import { PureComponent } from 'react'
import _ from 'lodash'

import { createSelector } from 'reselect'
import { mergeFilesByUid, getIsAnyFileUploading } from '../../../../lib/uploaderUtil'
import { UPLOAD_FILES_FIELD_NAME, MEDIA_UPLOADER_ID } from '../../../../constants/formTypes'
import { ANT_UPLOAD_STATUS } from '../../../../constants/globalTypes'
import UiStateContainer, { defaultUiContextCosumer } from '@vzmi/ec-react-ui-state-container'
import { getUploadStateByUI } from '../ProposalForm/Shared/util'

const getUploadFiles = state => _.get(state, UPLOAD_FILES_FIELD_NAME)

const uploadFilesSelector = createSelector(
  [getUploadFiles],
  uploadFiles => uploadFiles || {}
)

const withProposalListingFormUploadFiles = MainComponent => {
  class ProposalListingFormUploadFiles extends PureComponent {
    updateUploadFiles = inputFile => {
      const { ui, setIsUploading } = this.props
      const uiState = getUploadStateByUI(ui)
      const { uploadFiles } = uploadFilesSelector(uiState)

      const file = _.isEmpty(inputFile)
        ? {}
        : inputFile

      const files = _.compact(
        Array.isArray(file)
          ? file
          : [file]
      )

      const localFiles = _.compact(
        _.map(
          files,
          localFile => {
            const pickedFile = _.pick(
              localFile,
              ['uid', 'status', 'uploaded', 'percent']
            )

            return _.isEmpty(pickedFile)
              ? null
              : pickedFile
          }
        )
      )

      const mergedUploadFiles = mergeFilesByUid(
        _.isEmpty(uploadFiles)
          ? localFiles
          : uploadFiles,
        localFiles
      )

      const nextUploadFiles = _.filter(
        mergedUploadFiles,
        (localFile = {}) => (
          (localFile.status === ANT_UPLOAD_STATUS.UPLOADING) && (localFile.percent !== 100)
        )
      )

      const isMediaUploading = getIsAnyFileUploading(nextUploadFiles)

      if (setIsUploading) {
        setIsUploading(isMediaUploading)
      }

      return ui.setState(
        MEDIA_UPLOADER_ID,
        {
          isMediaUploading,
          [UPLOAD_FILES_FIELD_NAME]: nextUploadFiles
        })
    }

    render () {
      return (
        <MainComponent
          {...this.props}
          updateUploadFiles={this.updateUploadFiles}
        />
      )
    }
  }

  const FinalComp = UiStateContainer.createUi(
    ProposalListingFormUploadFiles,
    defaultUiContextCosumer
  )

  return FinalComp
}

export default withProposalListingFormUploadFiles
